module.exports = __webpack_public_path__ + "img/etuanjian.368e0872.jpg";